<!-- <div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    travelInfoData.bannerImage
      ? 'url(' + travelInfoData.bannerImage + ')'
      : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
>
  <div class="bannerText"></div>
</div> -->
<div (click)="imageClick(0)" class="innerBanner">
  <img
    class="innerBanner"
    *ngIf="travelInfoData.bannerImage; else noImage"
    [src]="travelInfoData.bannerImage"
    alt="Banner Image"
  />

  <ng-template #noImage>
    <img class="innerBanner" src="../../../assets/images/NoImage.jpg" alt="Banner Image" />
  </ng-template>

  <div class="bannerText"></div>
</div>
<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<div class="container contentPanel">
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <app-breadcrumb-row></app-breadcrumb-row>
  <h1>{{ travelInfoData.bannerTitle }}</h1>
  <p [innerHTML]="travelInfoData.bannerContent"></p>
  <!-- <p>&nbsp;</p> -->

  <div class="cetegoriesPanel">
    <div class="noMobile">
      <!-- <h1 translate class="text-center">{{ filteredData[0].name }}</h1> -->
      <div class="">
        <p-tabView class="about-us-tabs">
          <p-tabPanel>
            <ng-template pTemplate="header">
              <div
                *ngFor="let item of travelInfoDataItems; let imageIndex = index"
                class="aboutUsTabView"
                id="{{ imageIndex }}"
                [style.background-image]="
                  item.bannerImage
                    ? 'url(' + item.bannerImage + ')'
                    : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                "
                (click)="getTravelInfoDetails(item, imageIndex)"
              >
                <span>{{ item.bannerTitle }}</span>
              </div>
              <div
                *ngIf="generalService.bannerImage"
                class="aboutUsTabView"
                [style.background-image]="
                  generalService.bannerImage
                    ? 'url(' + generalService.bannerImage + ')'
                    : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                "
                (click)="getTravelInfoDetails('GENSERVICE')"
              >
                <span>{{ generalService.bannerTitle }}</span>
              </div>
              <div
                class="aboutUsTabView"
                [style.background-image]="
                  infoServices.bannerImage
                    ? 'url(' + infoServices.bannerImage + ')'
                    : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                "
                (click)="getTravelInfoDetails('INFO')"
              >
                <!-- <img src="{{ .bannerImage }}" style="height: 200px;width:200px;"
                                 /> -->
                <span>{{ infoServices.bannerTitle }}</span>
              </div>
            </ng-template>
            <div class="tabContent">
              <div *ngIf="showAdvisory">
                <div class="text-center banner-content" [innerHTML]="travelInfoDataNew.bannerContent"></div>
                <div class="gallery p-grid">
                  <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery" class="mp-0 p-col-12 p-md-4 p-lg-4">
                    <div
                      class="gallery-item"
                      [style.background-image]="
                        galleryItem.url
                          ? 'url(' + galleryItem.url + ')'
                          : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                      "
                      [style.background-repeat]="'no-repeat'"
                      (click)="openGalleryItemPopup(galleryItem)"
                    >
                      <span class="gallery-item-title"
                        ><strong>{{ galleryItem.gridTitle }}</strong></span
                      >
                    </div>
                  </div>
                </div>
                <p class="text-center mt-4 banner-content2" [innerHTML]="travelInfoDataNew.bannerContent2"></p>
                <div class="gallery p-grid">
                  <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery2" class="mp-0 p-col-12 p-md-4 p-lg-4">
                    <div
                      class="gallery-item"
                      [style.background-image]="
                        galleryItem.url
                          ? 'url(' + galleryItem.url + ')'
                          : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                      "
                      [style.background-repeat]="'no-repeat'"
                      (click)="openGalleryItemPopup(galleryItem)"
                    >
                      <span class="gallery-item-title"
                        ><strong>{{ galleryItem.gridTitle }}</strong></span
                      >
                    </div>
                  </div>
                </div>
                <p class="text-center alert-text mt-4" [innerHTML]="travelInfoDataNew.note"></p>
              </div>
              <div *ngIf="!showAdvisory">
                <h1>{{ travelInfoSelectedData.bannerTitle }}</h1>
                <p [innerHTML]="travelInfoSelectedData.bannerContent"></p>
                <img src="{{ travelInfoSelectedData.bannerImage }}" />
                <p>&nbsp;</p>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
    <div class="noDesktop">
      <p-accordion class="mb-3">
        <p-accordionTab
          (onOpen)="onTabOpen($event)"
          (onClose)="onTabClose($event)"
          header="{{ item.bannerTitle }}"
          *ngFor="let item of travelInfoDataItems; let ind = index"
          [selected]="activeState[ind]"
        >
          <div class="tabContent">
            <div *ngIf="ind == 0">
              <div class="text-center banner-content" [innerHTML]="travelInfoDataNew.bannerContent"></div>
              <div class="gallery p-grid">
                <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery" class="mp-0 p-col-12 p-md-4 p-lg-4">
                  <div
                    class="gallery-item"
                    [style.background-image]="
                      galleryItem.url
                        ? 'url(' + galleryItem.url + ')'
                        : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                    "
                    [style.background-repeat]="'no-repeat'"
                    (click)="openGalleryItemPopup(galleryItem)"
                  >
                    <span class="gallery-item-title"
                      ><strong>{{ galleryItem.gridTitle }}</strong></span
                    >
                  </div>
                </div>
              </div>
              <p class="text-center mt-4 banner-content2" [innerHTML]="travelInfoDataNew.bannerContent2"></p>
              <div class="gallery p-grid">
                <div *ngFor="let galleryItem of travelInfoDataNew.travelGallery2" class="mp-0 p-col-12 p-md-4 p-lg-4">
                  <div
                    class="gallery-item"
                    [style.background-image]="
                      galleryItem.url
                        ? 'url(' + galleryItem.url + ')'
                        : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
                    "
                    [style.background-repeat]="'no-repeat'"
                    (click)="openGalleryItemPopup(galleryItem)"
                  >
                    <span class="gallery-item-title"
                      ><strong>{{ galleryItem.gridTitle }}</strong></span
                    >
                  </div>
                </div>
              </div>
              <p class="text-center alert-text mt-4" [innerHTML]="travelInfoDataNew.note"></p>
            </div>
            <div *ngIf="ind !== 0">
              <!-- <h1>{{ item.bannerTitle }}</h1> -->
              <p [innerHTML]="item.bannerContent"></p>
              <img src="{{ item.bannerImage }}" />
              <p>&nbsp;</p>
            </div>
          </div>
        </p-accordionTab>

        <!-- <p-accordionTab header="{{ travelEssesntial.bannerTitle }}" [selected]="false">
<div class="container contentPanel">
<h1>{{ travelEssesntial.bannerTitle }}</h1>
<p [innerHTML]="travelEssesntial.bannerContent"></p>
<img src="{{ travelEssesntial.bannerImage}}"/>
<p>&nbsp;</p>
</div>
</p-accordionTab>
<p-accordionTab header="{{ bestTimeToVisit.bannerTitle }}" [selected]="false">
<div class="container contentPanel">
<h1>{{ bestTimeToVisit.bannerTitle }}</h1>
<p [innerHTML]="bestTimeToVisit.bannerContent"></p>
<img src="{{ bestTimeToVisit.bannerImage}}"/>
<p>&nbsp;</p>
</div>
</p-accordionTab> -->

        <p-accordionTab
          header="{{ generalService.bannerTitle }}"
          (click)="getTravelInfoDetails('GENSERVICE')"
          [selected]="false"
        >
          <div class="">
            <h1>{{ generalService.bannerTitle }}</h1>
            <p [innerHTML]="generalService.content"></p>
            <img src="{{ generalService.bannerImage }}" />
            <p>&nbsp;</p>
          </div>
        </p-accordionTab>

        <p-accordionTab
          header="{{ infoServices.bannerTitle }}"
          (click)="getTravelInfoDetails('INFO')"
          [selected]="false"
        >
          <div class="">
            <h1>{{ infoServices.bannerTitle }}</h1>
            <p [innerHTML]="infoServices.content"></p>
            <img src="{{ infoServices.bannerImage }}" />
            <p>&nbsp;</p>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
<p-dialog
  header="{{ selectedGalleryItem?.gridPopupTitle }}"
  [(visible)]="showGalleryItemPopup"
  [baseZIndex]="10000"
  [closable]="true"
  [modal]="true"
  (onHide)="closeGalleryItemPopup()"
  styleClass="customDialog"
>
  <!-- <h3 class="text-center popup-title">{{selectedGalleryItem?.gridPopupTitle}}</h3> -->
  <div class="popup-content" [innerHTML]="selectedGalleryItem?.gridPopupDescription"></div>
</p-dialog>
